import IComponent from "components/commons/IComponent";
import "./Measurement.scoped.css";
import MeasurementTool from "@arcgis/core/widgets/Measurement";
import geometryTools from "utils/geometryTools";
import SwitchTabs from "components/commons/SwitchTabs";
import IdentifyManager from "components/MapViews/IdentifyManager";
import DrawTool from "components/commons/DrawTool";
import GraphicStyleEditor from "./GraphicStyleEditor";
import Button from "@material-ui/core/Button";
import DivTable from "components/commons/DivTable";
import EditableDatagridCell from "components/commons/EditableDatagridCell";

class Measurement extends IComponent {
  gLayer = undefined;
  fileRef = undefined;
  constructor(props) {
    super(props);
    this.state = {
      measuringTool: null,
      measureData: {},
      activeTool: 0,
      isCleared: true,
      editingGraphic: undefined,
      is3DMode: false,
    };
    this.gLayer = geometryTools.createGraphicsLayerById(
      "measurementLayer",
      props.mapView.map
    );
  }
  componentDidMount() {
    IdentifyManager.enableIdentify = false;
    this.createUpdateMeasuringTool();
  }
  componentDidUpdate(prevProp) {
    if (prevProp.mapView != this.props.mapView) {
      this.createUpdateMeasuringTool();
    }
  }
  componentWillUnmount() {
    this.state.measuringTool && this.state.measuringTool.destroy();
    this.props.mapView?.map &&
      geometryTools.clearGraphicsByLayerId(
        "measureLayer",
        this.props.mapView.map
      );
    IdentifyManager.enableIdentify = true;
  }
  createUpdateMeasuringTool() {
    let measuringTool,
      vm = this;

    if (!this.state.measuringTool) {
      measuringTool = new MeasurementTool({
        view: this.props.mapView,
      });
      measuringTool.viewModel.watch("state", (newV, oldV) => {
        if (newV == "measured") {
          let tmpMeasureResult =
            measuringTool.viewModel.activeViewModel.measurement;
          vm.handleMeasuredData(tmpMeasureResult);
          if (
            measuringTool.viewModel.activeViewModel.tool.analysisViewData?.path
          ) {
            let calcHeight = this.calculateHeight(
              measuringTool.viewModel.activeViewModel.tool.analysisViewData.path
                ._editGeometry.geometry
            );
            let calcVolume = 0;
            if (calcHeight && tmpMeasureResult.area) {
              calcVolume = this.calculateVolume(
                calcHeight,
                tmpMeasureResult.area.text
              );
            }
            geometryTools.refreshGraphicInMeasureLayerById(
              vm.props.mapView,
              "measureLayer",
              [
                measuringTool.viewModel.activeViewModel.tool.analysisViewData
                  .path._editGeometry.geometry,
              ],
              calcHeight
            );
            tmpMeasureResult.verticalDistance = {
              text: `${Math.round(calcHeight * 100) / 100} m`,
            };
            tmpMeasureResult.volume = {
              text: `${(
                Math.round(calcVolume * 100) / 100
              ).toLocaleString()} m³`,
            };
            vm.handleMeasuredData(tmpMeasureResult);
          } else {
            geometryTools.clearGraphicsByLayerId(
              "measureLayer",
              this.props.mapView.map
            );
            let calcSlopeGradient = 0;
            if (!tmpMeasureResult.area) {
              if (
                tmpMeasureResult.verticalDistance &&
                tmpMeasureResult.horizontalDistance
              ) {
                calcSlopeGradient = this.calcSlopeGradient(
                  tmpMeasureResult.horizontalDistance.text,
                  tmpMeasureResult.verticalDistance.text
                );

                console.log(
                  "tmpMeasureResult.slopeGradient",
                  calcSlopeGradient
                );
                tmpMeasureResult.slopeGradient = {
                  text: `${(
                    Math.round(calcSlopeGradient * 100) / 100
                  ).toLocaleString()} degree`,
                };
                console.log(
                  "tmpMeasureResult.slopeGradient",
                  tmpMeasureResult.slopeGradient
                );
                vm.handleMeasuredData(tmpMeasureResult);
              }
            }
          }
        }
      });
      this.setState({
        measuringTool,
      });
    } else {
      measuringTool = this.state.measuringTool;
      measuringTool.clear();
      measuringTool.view = this.props.mapView;
      geometryTools.clearGraphicsByLayerId(
        "measureLayer",
        this.props.mapView.map
      );
    }
  }
  calculateHeight(geometry) {
    let minHeight = null;
    let maxHeight = null;

    //geting minimum z value from vertices.
    geometry.rings[0].forEach((item) => {
      //console.log(item)
      if (maxHeight == null) maxHeight = item[2];
      else if (maxHeight <= item[2]) maxHeight = item[2];
      if (minHeight == null) minHeight = item[2];
      else if (minHeight >= item[2]) minHeight = item[2];
    });

    let height = Math.abs(maxHeight - minHeight);
    return height;
  }
  calcSlopeGradient(horiDis, verDis) {
    horiDis = Number(horiDis.match(/([0-9\.]+)/)[0]);
    verDis = Number(verDis.match(/([0-9\.]+)/)[0]);
    return (90 - (Math.atan(horiDis / verDis) * 180) / Math.PI).toFixed(2);
  }
  calculateVolume(height, area) {
    if (!area) return NaN;
    return `${(Number(area.replace(/m²|\,/g, "")) * Math.round(height * 100)) /
      100}`;
  }
  handleMeasuredData(data) {
    console.debug(data);
    var measureData = Object.keys(data).reduce((p, c) => {
      if (typeof data[c] == "number") p[c] = data[c];
      else p[c] = data[c]?.text;
      return p;
    }, {});
    this.setState({ measureData });
  }
  onDrawCompletedHandler(geometry, symbol) {
    if (!geometry) {
      this.gLayer.removeAll();
      this.setState({ editingGraphic: undefined });
      return;
    }
    let attributes = {};
    if (geometry.type !== "point") {
      let area =
        geometry.type === "polygon"
          ? geometryTools.geometryEngine.planarArea(geometry, "square-meters")
          : undefined;
      let length = geometryTools.geometryEngine.planarLength(
        geometry,
        "meters"
      );
      attributes = { area, length };
    }

    let graphic = new geometryTools.Graphic({
      attributes,
      geometry,
      symbol:
        symbol.type === "text"
          ? symbol
          : geometryTools.highlightSymbol[geometry.type],
    });
    this.gLayer.add(graphic);
    this.setState({});
    return true;
  }
  updateGraphic(newSymbol) {
    this.state.editingGraphic.symbol = newSymbol.clone();
  }
  exportToJson() {
    let jsonObj = this.gLayer.graphics.map((i) => i.toJSON());
    let json = JSON.stringify(jsonObj);

    let filename = "CustomGraphics.json";
    let type = "application/json";
    var a = document.createElement("a"),
      file = new Blob([json], { type: type });
    var url = URL.createObjectURL(file);
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(function() {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 0);
  }
  importFromJson() {
    let vm = this;
    this.props.showDialog({
      isOpen: true,
      title: "Choose the custom graphics JSON file to import",
      content: (
        <input
          type="file"
          onChange={(e) => {
            vm.fileRef = e.target.files[0];
          }}
        />
      ),
      onDialogOk: async function() {
        if (!vm.fileRef) return false;
        try {
          let jsonContent = await vm.fileRef.text();
          let json = JSON.parse(jsonContent);
          if (!Array.isArray(json))
            throw new Error("The file is not a valid custom graphics file!");
          let graphics = json.map((i) => geometryTools.Graphic.fromJSON(i));
          graphics.forEach((g) => {
            if (!g.geometry) return;
            let attr = {};
            switch (g.geometry.type) {
              case "polygon":
                attr.area = geometryTools.geometryEngine.planarArea(
                  g.geometry,
                  "square-meters"
                );
              case "polyline":
                attr.length = geometryTools.geometryEngine.planarLength(
                  g.geometry,
                  "meters"
                );
                break;
              default:
                return;
            }
            g.attributes = attr;
          });
          vm.gLayer.removeAll();
          vm.gLayer.addMany(graphics);
          vm.setState({});
        } catch (e) {
          vm.props.showDialog({
            isOpen: true,
            type: "error",
            title: "Failed to import custom graphics",
            content: e.toString(),
            onDialogOk: () => {},
          });
        }
      },
      onDialogCancel: () => {
        vm.fileRef = undefined;
      },
    });
  }
  calculateAngle(length, height = "") {
    let vm = this;
    let heightString = height;
    let heightFloat = 0;
    if (height[height.length - 1] === ".") heightString = heightString + "0";
    heightFloat = parseFloat(heightString);
    if (isNaN(heightFloat)) heightFloat = 0;
    let angle = (Math.atan2(heightFloat, length) * 180) / Math.PI;
    angle.toFixed(2);
    this.props.showDialog({
      isOpen: true,
      title: "Calculate Angle",
      content: (
        <div className="AngleCalc">
          <div className="EqualWidthChildren">
            <div>Height</div>
            <div>Angle</div>
          </div>
          <div className="EqualWidthChildren">
            <div>
              <EditableDatagridCell
                cellInfo={{
                  colDef: {
                    field: "value",
                    dataType: "text",
                    required: false,
                    materialUiProps: {
                      classes: {
                        root: "SmallerMUIController",
                      },
                    },
                  },
                  row: { value: height },
                }}
                onChange={(field, value, values) => {
                  vm.calculateAngle(length, value);
                }}
              />
            </div>
            <div>{angle}&deg;</div>
          </div>
        </div>
      ),
      onDialogOk: () => {},
    });
  }
  async highlightGraphic(row, clear = false) {
    if (clear) {
      this.props.mapView.graphics.removeAll();
      return;
    }
    if (!row?.graphic?.geometry) return;
    let cloneGraphic = row.graphic.clone();
    cloneGraphic.symbol.color = "#FF0000";
    geometryTools.flashSymbol(
      this.props.mapView.graphics,
      cloneGraphic,
      (g, v) => {
        if (g.symbol.outline) g.symbol.outline.width = 5 * v + 1;
        if (g.symbol.width) g.symbol.width += 5 * v + 1;
      }
    );
  }
  render() {
    let {
      measureData,
      measuringTool,
      activeTool,
      isCleared,
      editingGraphic,
      is3DMode,
    } = this.state;

    let data = this.gLayer.graphics.map((i) => ({
      type: i.symbol?.type === "text" ? "Text" : i.geometry?.type || "ERROR",
      length: i.attributes?.length,
      area: i.attributes?.area,
      graphic: i,
    }));

    return (
      <div className={`MeasurementContainer${is3DMode ? " Mode3D" : ""}`}>
        <div className="PanelTitle">
          <span>
            Measurement
            {this.props.mapType === 3 && (
              <span
                className={`icon_l Switch3DButton ${
                  is3DMode ? "icn_2d_goto3d" : "icn_3d_goto2d"
                }`}
                onClick={() => this.setState({ is3DMode: !is3DMode })}
              />
            )}
          </span>
        </div>
        <div className="PanelContent">
          <div className="SubPanelContent">
            <DrawTool
              mapView={this.props.mapView}
              onDrawComplete={this.onDrawCompletedHandler.bind(this)}
            />
          </div>
          <div className="SubPanelContent" style={{ height: "300px" }}>
            {this.props.mapType === 3 && !is3DMode && (
              <div className="ProjectedAreaWarning">
                The area and length are measured on a projected area
              </div>
            )}
            <DivTable
              data={data}
              columnDef={[
                {
                  name: "Type",
                  value: "type",
                  width: "100px",
                  format: (value, row) => (
                    <span
                      className="BookmarkLink"
                      onMouseOver={() => this.highlightGraphic(row)}
                      onMouseLeave={() => this.highlightGraphic(row, true)}
                    >
                      {value}
                    </span>
                  ),
                },
                {
                  name: "Length",
                  value: "length",
                  nullValue: "--",
                  format: (value, row) => (
                    <div>
                      {Math.round(value * 100) / 100} m{" "}
                      {row.type === "polyline" && (
                        <span
                          className="icn_elevation icon_s"
                          onClick={() => {
                            this.calculateAngle(parseFloat(value));
                          }}
                        />
                      )}
                    </div>
                  ),
                },
                {
                  name: "Area",
                  value: "area",
                  nullValue: "--",
                  format: (value) => (
                    <span>
                      {Math.abs(Math.round(value * 100) / 100)} m<sup>2</sup>
                    </span>
                  ),
                },
              ]}
              actionColumn={[
                {
                  className: "icn_3d_Elevationprofile_draw icon_s",
                  onClick: (row) =>
                    this.setState(
                      {
                        editingGraphic: undefined,
                      },
                      () =>
                        this.setState({
                          editingGraphic: row.graphic,
                        })
                    ),
                },
                {
                  className: "icn_graphicsearch_delete icon_s",
                  onClick: (row) => {
                    this.gLayer.remove(row.graphic);
                    this.setState({});
                  },
                },
              ]}
              noDataText={
                data.length === 0 && (
                  <div>
                    No custom graphic yet. Get started by adding some new
                    graphic on the map!
                  </div>
                )
              }
            />
          </div>
          {editingGraphic && (
            <div className="SubPanelContent">
              <GraphicStyleEditor
                graphic={editingGraphic}
                onUpdate={this.updateGraphic.bind(this)}
              />
            </div>
          )}
          <div className="SubPanelContent">
            <Button
              onClick={() => {
                this.exportToJson();
              }}
              variant="outlined"
              classes={{ root: "actionBtn" }}
            >
              Export
            </Button>{" "}
            <Button
              onClick={() => {
                this.importFromJson();
              }}
              variant="outlined"
              classes={{ root: "actionBtn" }}
            >
              Import
            </Button>
          </div>
        </div>
        <div className="PanelContent3D SubPanelContent">
          <SwitchTabs
            isIconTabs={true}
            tabText={[
              "icn_graphicsearch_line",
              "icn_graphicsearch_area",
              "icn_tool_cleanall",
            ]}
            onSwitchTabCallback={(e, title) => {
              this.setState({ measureData: {} });
              let tool = "";
              switch (title) {
                case "icn_graphicsearch_line":
                  tool = this.props.mapType == 2 ? "distance" : "direct-line";
                  break;
                case "icn_graphicsearch_area":
                  tool = "area";
                  break;
                case "icn_tool_cleanall":
                  measuringTool.clear();
                  geometryTools.clearGraphicsByLayerId(
                    "measureLayer",
                    this.props.mapView.map
                  );
                  this.setState({ isCleared: true });
                  return true;
              }
              if (measuringTool.activeTool != tool) measuringTool.clear();
              geometryTools.clearGraphicsByLayerId(
                "measureLayer",
                this.props.mapView.map
              );
              measuringTool.activeTool = tool;
              measuringTool.startMeasurement();
              this.setState({ activeTool: e, isCleared: false });
            }}
            activedTab={-1}
          />
          <div>
            <table className="MeasureResultTable">
              <tbody>
                {isCleared && (
                  <tr>Get started by drawing a line or area on the map</tr>
                )}
                <tr
                  style={
                    !(activeTool == 0
                      ? measureData.directDistance || measureData.length
                      : measureData.perimeter || measureData.perimeterLength)
                      ? { display: "none" }
                      : { display: "" }
                  }
                >
                  <td>Length (m)</td>
                  <td>
                    {(activeTool == 0
                      ? measureData.directDistance || measureData.length
                      : measureData.perimeter || measureData.perimeterLength) ||
                      "--"}
                  </td>
                </tr>
                <tr
                  style={
                    !measureData.horizontalDistance
                      ? { display: "none" }
                      : { display: "" }
                  }
                >
                  <td>Horizontal (m)</td>
                  <td>{measureData.horizontalDistance || "--"}</td>
                </tr>
                <tr
                  style={
                    !measureData.verticalDistance
                      ? { display: "none" }
                      : { display: "" }
                  }
                >
                  <td>Vertical (m)</td>
                  <td>{measureData.verticalDistance || "--"}</td>
                </tr>
                <tr
                  style={
                    !measureData.slopeGradient
                      ? { display: "none" }
                      : { display: "" }
                  }
                >
                  <td>Slope Gradient (Degree)</td>
                  <td>{measureData.slopeGradient || "--"}</td>
                </tr>
                <tr
                  style={
                    !measureData.area ? { display: "none" } : { display: "" }
                  }
                >
                  <td>
                    Area (m<sup>2</sup>)
                  </td>
                  <td>{measureData.area || "--"}</td>
                </tr>
                <tr
                  style={
                    !measureData.volume ? { display: "none" } : { display: "" }
                  }
                >
                  <td>
                    Volume (m<sup>3</sup>)
                  </td>
                  <td>{measureData.volume || "--"}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export default Measurement;
